import { formatCopy, useNamespaceCopy } from '@/i18n/ns';
import safetyCopy from '@/i18n/ns/meeting-recording-safety';
import { recorderBacklogSeconds, useMeetingRecorder } from './meeting-recorder';

export function MeetingRecordingSafety() {
  const copy = useNamespaceCopy(safetyCopy);
  const acked = useMeetingRecorder((state) => state.ackedSamples);
  const backlog = useMeetingRecorder(recorderBacklogSeconds);
  const storage = useMeetingRecorder((state) => state.localStorage);
  const warning = useMeetingRecorder((state) => state.storageWarning);
  const phase = useMeetingRecorder((state) => state.phase);
  const incomplete = useMeetingRecorder((state) => state.upload.incomplete);
  const recovered = useMeetingRecorder((state) => state.recovered);
  const local = !storage.durable ? 'memory' : storage.state;
  return (
    <>
      <span data-testid="recording-cloud-ack">
        {acked === null
          ? copy.cloudUnknown
          : formatCopy(copy.cloud, { seconds: Math.floor(acked / 16000) })}
      </span>
      {(backlog === null || backlog > 0) && (
        <span data-testid="recording-device-storage" data-storage={local}>
          {recovered && local === 'stored' ? copy.recoveryTail : copy[local]}
        </span>
      )}
      {warning && (
        <span className="ws-recording-notice" data-testid="recording-storage-warning">
          {copy[warning]}
        </span>
      )}
      {incomplete && (
        <span className="ws-recording-notice" data-testid="recording-incomplete">
          {copy.incomplete}
        </span>
      )}
      {(phase === 'recovering' || phase === 'interrupted') &&
        !(recovered && local === 'stored' && backlog === null) && <span>{copy.recoveryTail}</span>}
    </>
  );
}
